import React from "react";
import _ from "lodash";
import { ToastNotification, TOAST_TYPE, showToast } from "@acadia-ui/toast";
import MasterCampaignsStore from "../../../Flux/Stores/MasterCampaignsStore";

export const onPostPush = (platformName, data) => {
	const pushedCampaign = MasterCampaignsStore.getPushedCampaign();
	if (pushedCampaign) {
		const masterCampaign = data?.find((campaign) => {
			return campaign.MasterCampaignID === pushedCampaign.MasterCampaignID;
		});
		if (masterCampaign) {
			let activationCampaign = null;
			Object.values(masterCampaign.ActivationCampaigns).forEach((platformCampaigns) => {
				activationCampaign ||= platformCampaigns.find((campaign) => {
					return campaign.CampaignID.toString() === pushedCampaign.CampaignID.toString();
				});
			});
			if (activationCampaign) {
				if (activationCampaign.ExternalSystemStatusID == 3) {
					showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message={`Successfully Pushed Campaign to ${platformName}`} timed={5000} />);
				} else if (activationCampaign.ExternalSystemStatusID == 4) {
					showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message={`Campaign has been sent to queue`} timed={5000} />);
				} else {
					showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.ERROR} message={`Failed to push campaign to ${platformName}`} />);
				}
				MasterCampaignsStore.resetPushedCampaign();
			}
		}
	}
	if (platformName === "GCM" && MasterCampaignsStore.getGCMSuccess()) {
		showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message={"Successfully Pushed Campaign to GCM"} timed={5000} />);
		MasterCampaignsStore.resetGCMSuccess();
	}
};
